<template>
	<v-container fluid>
		<v-row class="mb-3">
			<v-col cols="7" md="6" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="me-5" style="color: #ff7e87" size="40">mdi-account-cog</v-icon>
					<p class="text-lg-h5 font-weight-600">{{ $t('personnel_list') }}</p>
				</div>

				<v-btn v-if="!isSmallScreen"
					class="text-capitalize bg-green-accent-1 box-shadow text-black isRounded ml-4 status-btn"
					height="51px">
					<span class="pa-2 ma-2 bg-green rounded-lg">{{
						this.activeUsers
					}}</span>
					{{ $t('Active') }}
				</v-btn>
				<v-btn v-if="!isSmallScreen"
					class="text-capitalize bg-red-accent-1 box-shadow text-black isRounded ml-4 status-btn"
					height="51px">
					<span class="pa-2 ma-2 bg-red rounded-lg">{{
						this.inactiveUsers
					}}</span>
					{{ $t('Inactive') }}
				</v-btn>
			</v-col>
			<v-col cols="5" md="6" class="d-flex align-center justify-end">
				<div>
					<v-btn class="text-capitalize isRounded box-shadow mx-4" prepend-icon="mdi-tune"
						append-icon="mdi-chevron-down" height="51px">
						{{ $t('filters') }}
					</v-btn>
				</div>
				<div>
					<v-btn class="text-capitalize isRounded box-shadow mx-4 bg-red-lighten-4" prepend-icon="mdi-plus"
						height="51px" @click="createAccount = true">
						{{ $t('new_account') }}
					</v-btn>
				</div>
			</v-col>
		</v-row>
		<v-card v-if="isFetchingIncidents" height="400px" class="d-flex" align="center">
			<v-card-text class="text-center my-auto">
				<v-progress-circular color="grey" :size="80" indeterminate class="mb-4 mx-auto" />
				<div>Generating Report...</div>
			</v-card-text>
		</v-card>

		<v-card v-else>
			<v-card-text>
				<div class="dashboard">
					<!-- Emit created -->
					<!-- @added = getALlList -->
					<data-table :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
						@openAgentEditor="openEditUserDialog" @openActiveInactiveDialog="openActiveInactiveDialog"
						@send-data="editData">
					</data-table>
				</div>
			</v-card-text>
		</v-card>
	</v-container>
	<v-dialog v-model="createAccount" width="1200" persistent="">
		<CreatePersonalDetailCard @close="createAccount = false" @save-form="saveForm" />

		<v-snackbar v-model="snackbar" :color="snackbarColor">
			<div class="d-flex justify-space-between">
				<div>{{ snackbarMessage }}</div>
				<v-icon color="white" @click="snackbar = false">mdi-close</v-icon>
			</div>
		</v-snackbar>
	</v-dialog>

	<v-dialog v-model="editDetail" width="1200" persistent="">
		<CreatePersonalDetailCard :personal-detail="personalDetail" @save-form="saveForm" @save-edit-form="saveEditForm"
			is-change-password-visible is-delete-account-visible @delete-account="deleteAccount"
			@close="editDetail = false" />

		<v-snackbar v-model="snackbar" :color="snackbarColor">
			<div class="d-flex justify-space-between">
				<div>{{ snackbarMessage }}</div>
				<v-icon color="white" @click="snackbar = false">mdi-close</v-icon>
			</div>
		</v-snackbar>
	</v-dialog>
</template>

<script>
import CreatePersonalDetailCard from '@/components/CreatePersonalDetailCard.vue'
import PersonnelListDataTable from '@/components/PersonnelListDataTable.vue'
import ownerService from '@/services/API/ownerService'

export default {
	name: 'HomeView',
	components: {
		'data-table': PersonnelListDataTable,
		CreatePersonalDetailCard,
	},
	data: () => ({
		editDetail: false,
		personalDetail: {},
		// email: '',
		// password: '',
		// firstName: '',
		// lastName: '',
		// phone: '',
		// department: '',
		// role: '',
		// status: null,
		currentRole: '',
		currentStatus: '',
		snackbar: false,
		snackbarMessage: '',
		snackbarColor: 'error',
		totalActivePersonnel: '',
		totalInactivePersonnel: '',
		selectStatus: [
			{ title: 'ACTIVE', color: 'text-green-lighten-2', value: true },
			{ title: 'INACTIVE', color: 'text-red-lighten-2', value: false },
		],
		roleList: [
			{ title: 'OWNER', color: 'text-green-lighten-2', value: 'Owner' },
			{
				title: 'ADMIN',
				color: 'text-red-lighten-2',
				value: 'administrator',
			},
		],
		items: [],
		createAccount: false,
		activeUsers: '0',
		inactiveUsers: '0',
		headers: [
			{
				text: 'Personnel detail',
				value: 'agentDetial',
				width: '25%',
			},
			{
				text: 'Department',
				value: 'specialization',
				width: '20%',
			},
			{
				text: 'Role',
				value: 'userRole',
				width: '25%',
			},
			{
				text: 'Status',
				value: 'status',
				width: '10%',
			},
			{
				text: '',
				value: 'edit',
				width: '10%',
			},
		],
	}),
	created() {
		this.listAdmin()
	},
	computed: {
		isSmallScreen() {
			return this.$vuetify.display.smAndDown
		},
		smallScreenHeaders() {
			return this.headers.filter((item) =>
				['Agent name', 'Skills', 'Status'].includes(item.text)
			)
		},
	},
	methods: {
		saveEditForm(personalDetail) {
			this.updateAccount(personalDetail)
		},
		async listAdmin() {
			await ownerService.listAdminRoles().then((response) => {
				this.items = response.data.data
				this.items.forEach((obj) => {
					if (obj.active === true) {
						this.activeUsers++
					} else {
						this.inactiveUsers++
					}
				})
			})
		},
		async deleteAccount(id) {
			await ownerService.deletePersonnelAccount(id).then((response) => {
				if (response.status === 200) {
					this.editDetail = false
					this.listAdmin()
				}
			})
		},
		editData(data) {
			this.personalDetail = { ...data, roleId: data.UserRoles[0].id }
			this.editDetail = true
		},
		saveForm(personalDetail) {
			if (
				personalDetail.email &&
				personalDetail.firstName &&
				personalDetail.phone &&
				personalDetail.password &&
				personalDetail.lastName &&
				personalDetail.active !== null &&
				personalDetail.roleId
			) {
				// All fields are filled, perform the save operation
				this.createNewAccount(personalDetail)
			} else {
				// Show snackbar with error message
				this.snackbarMessage = 'Please fill in all required fields.'
				this.snackbar = true
			}
		},
		async createNewAccount(personalDetail) {
			const accountDetail = { ...personalDetail }
			await ownerService
				.createNewAccount(accountDetail)
				.then((response) => {
					if (response.status === 200) {
						window.location.reload()
					}
				})
				.catch((error) => {
					this.snackbarMessage = error.message
					this.snackbar = true
				})
		},
		async updateAccount(personalDetail) {
			await ownerService
				.editPersonnelAccount(personalDetail.id, personalDetail)
				.then((response) => {
					if (response.status === 200) {
						this.editDetail = false
						this.listAdmin()
					}
				})
				.then(() => {
					window.location.reload()
				})
		},
		selectRole(item) {
			this.currentRole = item.title
			this.role = item.value
		},
		selectUserStatus(item) {
			this.currentStatus = item.title
			this.active = item.value
		},
	},
}
</script>
<style scoped>
.box-shadow {
	box-shadow: 0px 0px 16px 0px rgba(131, 133, 143, 0.1) !important;
}
</style>
